module.exports = __webpack_public_path__ + "img/New Zealander.de090a3e.svg";